import Api from '@/services/Index'

const sendSms = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/cartoon/animation/application/start', data)
}

const verifySms = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/cartoon/animation/application/verify', data)
}

const login = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/cartoon/animation/application/login', data)
}

const updatePersonalInfo = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/cartoon/animation/application/update-personal-information', data)
}

const updateEducationInfo = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/cartoon/animation/application/update-education-information', data)
}

const updateApplicationInfo = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/cartoon/animation/application/update-application-information', data)
}

const passwordReminder = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/cartoon/animation/application/password-reminder', formData)
}

const downloadFileApplicationSide = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/cartoon/animation/application/download-document', formData, {responseType: 'arraybuffer'})
}

/// Admin
const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/cartoon/animation/applications', config)
}

const update = async (formData, id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put('/cartoon/animation/applications/'+id, formData)
}

const downloadFile = async (applicationId, type) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/cartoon/animation/applications/download-file/'+applicationId+'/'+type, {responseType: 'arraybuffer'})
}

const sendMessage = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/cartoon/animation/application/messages', formData)
}

const updateMessage = async (formData, id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put('/cartoon/animation/application/messages/'+id, formData)
}

const deleteMessage = async (messageId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.delete('/cartoon/animation/application/messages/'+messageId)
}

const bulkMessage = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/cartoon/animation/applications/bulk-message', formData)
}

const getExamList = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('cartoon/animation/application/exam-list', formData)
}

const examInformationExcelExport = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/cartoon/animation/application/exam-information-excel-export', {responseType: 'arraybuffer'})
}

const importExamInformationExcelImport = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/cartoon/animation/application/exam-information-excel-import', formData)
}

const examResultExcelExport = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/cartoon/animation/application/exam-result-excel-export', {responseType: 'arraybuffer'})
}

const importExamResultExcelImport = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/cartoon/animation/application/exam-result-excel-import', formData)
}

const calculateExamPoints = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/cartoon/animation/application/calculate-exam-points')
}

const getExams = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/cartoon/animation/application/exams', config)
}

const updateExam = async (formData, Id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put('/cartoon/animation/application/exams/'+Id, formData)
}

const applicationExcelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/cartoon/animation/applications/excel-export', {...config, responseType: 'arraybuffer'})
}

const deleteApplication = async (Id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.delete('/cartoon/animation/applications/'+Id)
}

const makePayment = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/cartoon/animation/application/make-payment', formData)
}

const getAllExamTypes = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/cartoon/animation/application/exam-types', config);
}

const getExamType = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/cartoon/animation/application/exam-types/' + id);
}

const storeExamType = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/cartoon/animation/application/exam-types', data);
}
const updateExamType = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/cartoon/animation/application/exam-types/' + id, formData);
}

const delExamType = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/cartoon/animation/application/exam-types/' + id);
}

const getAllQuotas = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/cartoon/animation/application/quotas', config);
}

const getQuotas = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/cartoon/animation/application/quotas/${id}`);
}

const storeQuotas = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/cartoon/animation/application/quotas', data);
}

const updateQuotas = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put(`/cartoon/animation/application/quotas/${id}`, data);
}

const delQuotas = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete(`/cartoon/animation/application/quotas/${id}`);
}

const downloadDocumentsZip = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/cartoon/animation/application/download-documents', {...config, responseType: 'arraybuffer'})
}

export default {
    sendSms,
    verifySms,
    login,
    updatePersonalInfo,
    updateEducationInfo,
    updateApplicationInfo,
    getAll,
    passwordReminder,
    update,
    downloadFile,
    downloadFileApplicationSide,
    sendMessage,
    updateMessage,
    deleteMessage,
    bulkMessage,
    getExamList,
    examInformationExcelExport,
    importExamInformationExcelImport,
    examResultExcelExport,
    importExamResultExcelImport,
    calculateExamPoints,
    getExams,
    updateExam,
    applicationExcelExport,
    deleteApplication,
    makePayment,
    getAllExamTypes,
    getExamType,
    storeExamType,
    updateExamType,
    delExamType,
    getAllQuotas,
    getQuotas,
    storeQuotas,
    updateQuotas,
    delQuotas,
    downloadDocumentsZip

}
